import i18n from "~/lib/i18n";
import { resolveInitialLocale } from "~/lib/locale";
import { useLocaleStore } from "~/stores/useLocaleStore";

/** Applies cookie/navigator locale to the store, document lang, and i18n. */
export function applyInitialLocale(): void {
  const initialLocale = resolveInitialLocale();
  document.documentElement.lang = initialLocale;
  useLocaleStore.setState({ locale: initialLocale });

  if (initialLocale !== "en") {
    void i18n.loadLanguages(initialLocale);
    void i18n.changeLanguage(initialLocale);
  }
}
